import { render, staticRenderFns } from "./ybsbgfhList.vue?vue&type=template&id=063930e1&scoped=true&"
import script from "./ybsbgfhList.vue?vue&type=script&lang=js&"
export * from "./ybsbgfhList.vue?vue&type=script&lang=js&"
import style0 from "./ybsbgfhList.vue?vue&type=style&index=0&id=063930e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063930e1",
  null
  
)

export default component.exports